import type { WorkflowOptions } from '../../types';
import { generateAssetStatusWorkflow } from '../generateAssetStatusWorkflows';
import { editThirdPartyBillingAccount } from './editThirdPartyBillingAccount';
export const workflows: WorkflowOptions[] = [
  editThirdPartyBillingAccount,
  ...Object.values(generateAssetStatusWorkflow('thirdPartyBillingAccount')),
];
export default workflows;
